import React from 'react';
import SectionTitle from './SectionTitle';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';

const Section8Title = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const title = (
    <>
      <span>{context.sectionNumbers.section8}</span>
      <span>. הרקע הקנייני</span>
    </>
  );

  return context.display.section8 && <SectionTitle title={title} ref={ref}/>;
});

export default Section8Title;
